module.exports = __webpack_public_path__ + "static/media/tapa-doble-pag-cuadrada-fvcon.977dbe52.png";